// removed by extract-text-webpack-plugin
module.exports = {"Item":"_bPXGV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/DropdownMenu/DropdownMenuItem/DropdownMenuItem.scss
// module id = 535
// module chunks = 0